import * as React from 'react';
import { SVGProps } from 'react';

const NotFound404Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="0.5em"
    viewBox="0 0 381 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M276.919 112.077C277.002 111.757 277.081 111.434 277.161 111.111C277.083 111.434 277 111.756 276.919 112.077Z"
      fill="#AFE6FF"
    />
    <path
      d="M189.864 0.00012207C155.292 0.00012207 133.997 19.4995 133.938 19.5325C132.604 25.6912 130.283 34.6292 130.283 41.1873C130.283 90.8041 172.125 131.017 221.742 131.017C242.887 131.017 262.314 121.172 277.661 108.948C277.723 108.565 279.704 100.677 279.704 89.8395C279.704 40.2227 239.482 0.00012207 189.864 0.00012207Z"
      fill="#BD4A26"
    />
    <path
      d="M277.661 108.948C262.314 121.172 242.879 128.481 221.734 128.481C172.117 128.481 131.895 88.2581 131.895 38.6413C131.895 32.0829 132.604 25.6913 133.939 19.5326C133.936 19.5341 133.934 19.5359 133.932 19.5377C113.271 35.9973 100.025 61.37 100.025 89.8393C100.025 139.456 140.248 179.679 189.864 179.679C231.804 179.679 267.021 150.937 276.918 112.078C277 111.756 277.082 111.434 277.161 111.111C277.198 110.957 277.537 109.518 277.661 108.948Z"
      fill="#663627"
    />
    <path
      d="M263.382 89.8396C263.382 108.151 256.587 124.875 245.381 137.629C232.106 152.738 212.64 158.479 190.947 158.479C150.942 158.479 122.11 128.561 122.11 88.556C122.11 58.1249 137.277 33.3603 163.868 22.6357C172.233 19.2616 181.373 17.4044 190.947 17.4044C230.951 17.4041 263.382 49.8346 263.382 89.8396Z"
      fill="#F1D333"
    />
    <path
      d="M225.981 45.3238C225.206 45.3238 224.423 45.1082 223.723 44.6573C222.614 43.9418 221.463 43.2573 220.305 42.6228C218.283 41.5155 217.541 38.9787 218.648 36.9567C219.756 34.9341 222.293 34.1925 224.314 35.3001C225.647 36.0295 226.97 36.817 228.247 37.6402C230.185 38.8893 230.743 41.4724 229.494 43.4106C228.696 44.6486 227.352 45.3238 225.981 45.3238Z"
      fill="#F9EF63"
    />
    <path
      d="M209.415 37.4063C208.986 37.4067 208.55 37.3399 208.12 37.1998C202.595 35.3986 196.817 34.4853 190.947 34.4853C186.643 34.4853 182.357 34.9803 178.209 35.9569C175.965 36.4871 173.717 35.0944 173.189 32.8502C172.661 30.6061 174.052 28.3588 176.296 27.8303C181.07 26.706 185.999 26.1365 190.947 26.1365C197.697 26.1365 204.346 27.1879 210.708 29.262C212.9 29.9765 214.097 32.3329 213.383 34.5249C212.808 36.2869 211.173 37.4063 209.415 37.4063Z"
      fill="#F9EF63"
    />
    <path
      d="M218.301 142.862C178.296 142.862 145.866 110.432 145.866 70.4268C145.866 52.1152 152.664 35.3937 163.87 22.6398C137.279 33.3644 118.512 59.4084 118.512 89.8392C118.512 129.844 150.942 162.274 190.947 162.274C212.64 162.274 232.103 152.735 245.378 137.626C237.013 141 227.875 142.862 218.301 142.862Z"
      fill="#EAB14D"
    />
    <path
      d="M222.31 99.0532C226.35 99.0532 229.625 92.7026 229.625 84.8687C229.625 77.0347 226.35 70.6841 222.31 70.6841C218.27 70.6841 214.995 77.0347 214.995 84.8687C214.995 92.7026 218.27 99.0532 222.31 99.0532Z"
      fill="#EAB14D"
    />
    <path
      d="M222.211 93.7094C225.912 93.7094 228.912 88.555 228.912 82.1967C228.912 75.8385 225.912 70.6841 222.211 70.6841C218.51 70.6841 215.51 75.8385 215.51 82.1967C215.51 88.555 218.51 93.7094 222.211 93.7094Z"
      fill="#502618"
    />
    <path
      d="M181.945 99.0532C185.985 99.0532 189.26 92.7026 189.26 84.8687C189.26 77.0347 185.985 70.6841 181.945 70.6841C177.905 70.6841 174.63 77.0347 174.63 84.8687C174.63 92.7026 177.905 99.0532 181.945 99.0532Z"
      fill="#EAB14D"
    />
    <path
      d="M181.846 93.7094C185.547 93.7094 188.548 88.555 188.548 82.1967C188.548 75.8385 185.547 70.6841 181.846 70.6841C178.145 70.6841 175.145 75.8385 175.145 82.1967C175.145 88.555 178.145 93.7094 181.846 93.7094Z"
      fill="#502618"
    />
    <path
      d="M159.677 70.7199C159.323 70.7199 158.964 70.626 158.64 70.4293C157.694 69.8556 157.391 68.6232 157.965 67.6772C166.365 53.8235 180.069 55.1473 180.649 55.2099C181.749 55.3299 182.544 56.3186 182.424 57.4193C182.304 58.5175 181.314 59.306 180.222 59.1948C179.74 59.1471 168.432 58.1434 161.392 69.7548C161.015 70.3764 160.354 70.7199 159.677 70.7199Z"
      fill="#EAB14D"
    />
    <path
      d="M247.315 70.72C246.637 70.72 245.976 70.3762 245.599 69.7545C238.558 58.1397 227.247 59.1462 226.769 59.1945C225.678 59.3078 224.686 58.5089 224.57 57.4114C224.455 56.3135 225.245 55.3296 226.342 55.21C226.923 55.1478 240.627 53.8225 249.026 67.6773C249.6 68.6233 249.298 69.8557 248.351 70.4293C248.027 70.6261 247.669 70.72 247.315 70.72Z"
      fill="#EAB14D"
    />
    <path
      d="M275.025 68.3676L233.181 100.921L244.53 107.746L279.291 79.0811C281.457 77.2948 282.617 74.7409 282.701 72.139L275.025 68.3676Z"
      fill="#9DC6FB"
    />
    <path
      d="M280.561 65.8647C277.262 61.8641 271.345 61.2954 267.345 64.5943L233.181 92.767V106.322L272.98 73.5031C275.797 71.1801 279.565 70.7775 282.699 72.1389C282.771 69.9358 282.074 67.6989 280.561 65.8647Z"
      fill="#4FADDB"
    />
    <path
      d="M221.466 125.359C221.244 125.156 221.02 124.958 220.793 124.763C220.998 125.465 221.17 126.176 221.31 126.893L222.239 126.127C221.99 125.864 221.735 125.606 221.466 125.359Z"
      fill="#4FADDB"
    />
    <path
      d="M246.451 95.3799L215.83 116.45C218.828 119.202 220.544 122.964 221.31 126.894L244.53 107.746C246.692 105.962 247.945 103.306 247.945 100.503C247.945 98.5492 247.386 96.8126 246.451 95.3799Z"
      fill="#DD6938"
    />
    <path
      d="M216.404 117.006C216.434 117.036 216.461 117.067 216.49 117.097C216.65 117.262 216.806 117.429 216.958 117.6C216.972 117.617 216.986 117.633 217 117.65C217.166 117.838 217.326 118.031 217.483 118.226C217.484 118.227 217.485 118.229 217.486 118.23C217.652 118.438 217.813 118.65 217.968 118.866L246.449 95.3804C243.585 90.9919 237.201 89.4518 232.584 93.2579L225.586 99.0288L209.545 112.257C211.826 113.279 213.934 114.708 215.831 116.449C216.028 116.631 216.218 116.817 216.404 117.006Z"
      fill="#D80A61"
    />
    <path
      d="M219.718 136.011C219.486 136.011 219.25 135.978 219.015 135.909C217.687 135.522 216.925 134.132 217.313 132.803C218.839 127.575 217.397 121.937 213.549 118.089C210.738 115.278 207 113.729 203.023 113.729C199.046 113.729 195.308 115.278 192.496 118.089C191.518 119.067 189.932 119.067 188.954 118.089C187.976 117.111 187.976 115.525 188.954 114.547C192.712 110.789 197.709 108.72 203.023 108.72C208.337 108.72 213.334 110.789 217.092 114.547C222.233 119.688 224.16 127.222 222.121 134.207C221.803 135.301 220.803 136.011 219.718 136.011Z"
      fill="#502618"
    />
    <path
      d="M0 127.5V106.8L47.4 39H76.05V105.3H88.35V127.5H76.05V147H50.4V127.5H0ZM52.2 67.2L27 105.3H52.2V67.2Z"
      fill="#021337"
    />
    <path
      d="M292.236 127.5V106.8L339.636 39H368.286V105.3H380.586V127.5H368.286V147H342.636V127.5H292.236ZM344.436 67.2L319.236 105.3H344.436V67.2Z"
      fill="#021337"
    />
  </svg>
);

export default NotFound404Icon;
